import { createContext, useContext } from 'react'
import type { CalendarContextValue } from '@/types'

export const CalendarContext = createContext<CalendarContextValue | undefined>(
  undefined,
)

export const useCalendar: () => CalendarContextValue = () => {
  const context = useContext(CalendarContext)

  if (!context)
    throw new Error('useCalendar must be used within CalendarProvider')

  return context
}
